import Edit from "./edit"
import View from "./view"

export default { edit: Edit, view: View }
